import { CheckCircle } from "lucide-react";
import adminImg from "../../../Assets/Images/adminImg.png";
import hand_heart from "../../../Assets/Images/home/overview/hand_heart.png";
import SectionHeading from "./SectionHeading";

// Skeleton Loader for Overview
const SkeletonOverview = () => (
  <div className="py-6 px-4 sm:px-8 md:px-10 animate-pulse">
    <div className="flex flex-col md:flex-row items-center gap-8 rounded-lg">
      {/* Left Column Skeleton */}
      <div className="w-full md:w-1/2 flex justify-center">
        <div className="w-80 h-64 bg-gray-300 rounded-md" />
      </div>

      {/* Right Column Skeleton */}
      <div className="w-full md:w-1/2 space-y-4 md:pr-10 relative">
        <div className="h-6 bg-gray-300 rounded w-3/4" />
        <div className="h-4 bg-gray-300 rounded w-full" />
        <div className="h-4 bg-gray-300 rounded w-full" />
        <div className="flex flex-wrap gap-4 mt-2">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="h-6 bg-gray-300 rounded w-32" />
          ))}
        </div>
        <div className="flex flex-wrap gap-4 mt-2">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="h-6 bg-gray-300 rounded w-36" />
          ))}
        </div>
        <div className="flex flex-wrap gap-4 mt-2">
          <div className="h-6 bg-gray-300 rounded w-40" />
        </div>
      </div>
    </div>
  </div>
);

const OverView = ({ loading = false }) => {
  if (loading) return <SkeletonOverview />;

  return (
    <div className="py-6 px-4 sm:px-8 md:px-10">
      <div className="flex flex-col md:flex-row items-center gap-8 rounded-lg">
        {/* Left Column with Image */}
        <div
          className="w-full md:w-1/2 max-h-[30rem] flex justify-center"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <img
            src={adminImg}
            alt="AFSA Founder Speaking"
            className="rounded-md h-auto object-contain"
          />
        </div>

        {/* Right Column with Text */}
        <div
          className="w-full md:w-1/2 space-y-4 md:pr-10 relative"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <img
            src={hand_heart}
            className="absolute pt-2 -translate-y-[15%] sm:-translate-y-[20%] md:-translate-y-[30%] lg:-translate-y-[35%] xl:-translate-y-[40%] right-0 w-[15%] md:w-[60%] md:max-w-40"
            alt="hand_heart"
          />
          <SectionHeading
            subtitle="Overview"
            title=" AAFSA – The Hope of Humanity"
            textAlign="left"
          />
          <p
            className={`
              font-poppins font-normal align-middle text-[#4D4D4D] tracking-normal md:tracking-wide
              text-base text-justify leading-[1.375rem] md:text-[1rem] md:leading-[1.5rem]
            `}
          >
            Aryalex Foundation for Social Activities (AAFSA) is where compassion
            meets action. Founded in 2022 in Odisha, India, we are a grassroots,
            not-for-profit, secular, humanitarian, non-political, and
            non-governmental organization committed to transforming lives and
            creating lasting impact.
          </p>

          {/* Bullet Points */}
          <div className="flex flex-col gap-y-4 sm:gap-y-8">
            <div
              className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {["300 Women SHGs", "100 Paid Women Volunteers"].map((text) => (
                <BulletPoint key={text} text={text} />
              ))}
            </div>

            <div
              className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {["30 Women Led Social Enterprises", "5+ Districts Covered"].map(
                (text) => (
                  <BulletPoint key={text} text={text} />
                )
              )}
            </div>

            <div
              className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              {["15 Farmer’s Group Nurtured by Trained"].map((text) => (
                <BulletPoint key={text} text={text} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const BulletPoint = ({ text, size = 28 }) => {
  return (
    <div className="flex items-center gap-1">
      <CheckCircle className="text-sky-400 flex-shrink-0" size={size} />
      <span
        className="
          font-dm-sans font-medium align-middle text-[#08121A] tracking-wider
          text-[0.9rem] sm:text-[1.03rem] md:text-[1.1rem] lg:text-[1.3rem]
        "
      >
        {text}
      </span>
    </div>
  );
};

export default OverView;

// const OverView = ({ loading = false }) => {
//   if (loading) return <SkeletonOverview />;

//   return (
//     <div className="py-6 px-4 sm:px-8 md:px-10">
//       <div className="flex flex-col md:flex-row items-center gap-8 rounded-lg">
//         {/* Left Column with Image */}
//         <div
//           className="w-full md:w-1/2 max-h-[30rem] flex justify-center"
//           data-aos="fade-up"
//           data-aos-duration="800"
//         >
//           <img
//             src={speach}
//             alt="AFSA Founder Speaking"
//             className="rounded-md h-auto object-contain"
//           />
//         </div>

//         {/* Right Column with Text */}
//         <div
//           className="w-full md:w-1/2 space-y-4 md:pr-10 relative"
//           data-aos="fade-up"
//           data-aos-duration="800"
//         >
//           <img
//             src={hand_heart}
//             className="absolute pt-2 -translate-y-[15%] sm:-translate-y-[20%] md:-translate-y-[30%] lg:-translate-y-[35%] xl:-translate-y-[40%] right-0 w-[15%] md:w-[60%] md:max-w-40"
//             alt="hand_heart"
//           />
//           <SectionHeading
//             subtitle="Overview"
//             title=" AAFSA – The Hope of Humanity"
//             textAlign="left"
//           />
//           <p
//             className={`
//               font-poppins font-normal align-middle text-[#4D4D4D] tracking-normal md:tracking-wide
//               text-base text-justify leading-[1.375rem] md:text-[1rem] md:leading-[1.5rem]
//             `}
//           >
//             Aryalex Foundation for Social Activities (AAFSA) is where compassion
//             meets action. Founded in 2022 in Odisha, India, we are a grassroots,
//             not-for-profit, secular, humanitarian, non-political, and
//             non-governmental organization committed to transforming lives and
//             creating lasting impact.
//           </p>

//           {/* Bullet Points */}
//           <div className="flex flex-col gap-y-4 sm:gap-y-8">
//             <div
//               className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
//               data-aos="fade-up"
//               data-aos-delay="100"
//             >
//               {["300 Women SHGs", "100 Paid Women Volunteers"].map((text) => (
//                 <BulletPoint key={text} text={text} />
//               ))}
//             </div>

//             <div
//               className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
//               data-aos="fade-up"
//               data-aos-delay="200"
//             >
//               {["30 Women Led Social Enterprises", "5+ Districts Covered"].map(
//                 (text) => (
//                   <BulletPoint key={text} text={text} />
//                 )
//               )}
//             </div>

//             <div
//               className="flex flex-col sm:flex-row gap-x-4 md:gap-x-8 gap-y-4 sm:gap-y-0"
//               data-aos="fade-up"
//               data-aos-delay="300"
//             >
//               {["15 Farmer’s Group Nurtured by Trained"].map((text) => (
//                 <BulletPoint key={text} text={text} />
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
